import React from 'react'
import CozyFrontpage from '../images/Cozy_Frontpage.png' 
import { OurProducts } from './Data'

let colorNumber = 0

const OurProduct = () => {
  return (
    <div id='product' className='Product-Section'>
      <div className='Our-product'>
        <h2>UNSERE PRODUKTE</h2>
      </div>

   <div className='Products'>
        {OurProducts.map((product)=>{
          colorNumber = colorNumber + 1
          console.log(colorNumber)
            return(
                <div key={product.id} 
                     className='Product'
                     onClick={() => window.open(product.pdfLocation, "_blank")}
                        style={{ cursor: "pointer" }}>
                    <img src={CozyFrontpage}></img>
                    <h3>{product.headline1}</h3>
                    <h3>{product.headline2}</h3>
                    <p>{product.text}</p>
                </div>
            )
        })}
   </div>

    </div>

  )
}

export default OurProduct